var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-email.510215ca.png","uri@2x": __webpack_public_path__ + "icon-email.37421ee3.png","uri@3x": __webpack_public_path__ + "icon-email.8f68b04a.png",
    width: 20,
    height: 14
});